import { signaleNouvelleVersion } from './miseAJour';

/**
 * Enregistre le service worker, en production seulement.
 *
 * <p>En développement, Vite sert les modules un à un et les réécrit à chaque
 * enregistrement : un cache de coquille y servirait des versions périmées.
 *
 * <p>Quand une nouvelle version est installée derrière la page ouverte, elle
 * n'est pas activée d'office : l'écran le signale, et l'utilisateur recharge
 * quand il a fini ce qu'il faisait.
 */
export function enregistreServiceWorker() {
  if (!import.meta.env.PROD) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  const surveille = (worker) => {
    if (!worker) return;
    worker.addEventListener('statechange', () => {
      // « installed » avec un contrôleur déjà en place : c'est une mise à
      // jour, pas la première installation.
      if (worker.state === 'installed' && navigator.serviceWorker.controller) {
        signaleNouvelleVersion(worker);
      }
    });
  };

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((enregistrement) => {
        if (enregistrement.waiting && navigator.serviceWorker.controller) {
          signaleNouvelleVersion(enregistrement.waiting);
        }
        enregistrement.addEventListener('updatefound', () => surveille(enregistrement.installing));
        // Une application installée reste ouverte des jours : on revérifie à
        // chaque retour au premier plan.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            enregistrement.update().catch(() => undefined);
          }
        });
      })
      .catch(() => undefined);
  });

  // À la première visite, le service worker prend la main sur la page déjà
  // chargée : ce n'est pas une nouvelle version, rien à recharger. Recharger
  // là faisait ouvrir deux fois la page du client (« Ouvert 2 fois »).
  let controleur = navigator.serviceWorker.controller;
  let recharge = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!controleur) {
      controleur = navigator.serviceWorker.controller;
      return;
    }
    if (recharge) return;
    recharge = true;
    window.location.reload();
  });
}
